import React, { useState, useRef } from "react";
import Button from "../component/button/Button";
import ButtonLoad from "../component/button/ButtonLoad";
import InputOutline from "../component/input/InputOutline";
import AlertSuccess from "../component/alert/AlertSuccess";
import AlertFailed from "../component/alert/AlertFailed";
import logo from "../img/logo.svg";
import { urlApi } from "../setting/Url";
import CountdownTimer from "../component/countdown/CountdownTimer";
import { motion, AnimatePresence } from "framer-motion";
import { InputOtp } from "@heroui/react";

const VerifyOtp = ({
    data,
    modalVerifyOtp,
    setModalVerifyOtp,
    SendOtpCode,
}) => {
    const formRegister = useRef(null);

    // console.log(location);

    const [loadButton, setLoadButton] = useState(false);
    const [showNotif, setShowNotif] = useState(null);
    const [msgNotif, setMsgNotif] = useState({
        messageResponse: "",
        messageApi: "",
    });

    const processVerifyOtp = async (e) => {
        e.preventDefault();

        setLoadButton(true);

        const dataRegister = new FormData(formRegister.current);

        try {
            const response = await fetch(`${urlApi}/api/pelanggan/verify-otp`, {
                method: "POST",
                body: dataRegister,
            });

            const data = await response.json();

            if (data.status === "200") {
                setShowNotif(data.success);

                const messageData = {
                    messageResponse: "Mantap",
                    messageApi: data.messages,
                };

                setMsgNotif(messageData);
            }

            if (response.status == 400) {
                let message = "";

                const {
                    namaLengkap,
                    // username,
                    // email,
                    noHp,
                    password,
                    konfPassword,
                    layanan,
                } = data.messages.messages;

                if (namaLengkap != undefined) {
                    message = namaLengkap;
                } else if (noHp != undefined) {
                    message = noHp;
                } else if (password != undefined) {
                    message = password;
                } else if (konfPassword != undefined) {
                    message = konfPassword;
                } else if (layanan != undefined) {
                    message = layanan;
                }

                const messageData = {
                    messageResponse: message,
                    messageApi: "Anda gagal mendaftar!",
                };

                setLoadButton(false);

                setShowNotif(data.messages.success);

                setMsgNotif(messageData);
            }
            if (response.status == 500) {
                const messageData = {
                    messageResponse: "Server Sedang Error",
                    messageApi: "Anda gagal mendaftar!",
                };

                setLoadButton(false);

                setShowNotif(false);

                setMsgNotif(messageData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const dropInContainer = {
        hidden: {
            opacity: 0,
        },
        visible: {
            y: "0",
            opacity: 1,
            transition: {
                duration: 0.3,
                type: "spring",
                damping: 45,
                stiffness: 500,
            },
        },
        exit: {
            opacity: 1,
        },
    };

    const dropInContent = {
        hidden: {
            y: "100vh",
            opacity: 0,
        },
        visible: {
            y: "0",
            opacity: 1,
            transition: {
                duration: 0,
                type: "spring",
                damping: 55,
                stiffness: 500,
                delayChildren: 0.3,
                staggerChildren: 0.2,
            },
        },
        exit: {
            y: "100vh",
            opacity: 0,
            transition: {
                duration: 0.3,
                type: "spring",
            },
        },
    };

    return (
        <AnimatePresence
            // Disable any initial animations on children that
            // are present when the component is first rendered
            initial={false}
            // Only render one component at a time.
            // The exiting component will finish its exit
            // animation before entering component is rendered
            mode="wait"
            // Fires when all exiting nodes have completed animating out
            onExitComplete={() => null}
        >
            {modalVerifyOtp && (
                <motion.div
                    className="h-screen w-full bg-opacity-50 backdrop-blur-[2px] shadow-2xl fixed md:px-[35vw] left-0 bottom-0 bg-gray-900 transition flex justify-center items-end z-[100]"
                    onClick={() => setModalVerifyOtp(false)}
                    variants={dropInContainer}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <motion.div
                        className="relative w-full"
                        onClick={(e) => e.stopPropagation()}
                        variants={dropInContent}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        <span class="absolute right-[44%] top-[-2%] p-[3px] rounded-xl w-12 bg-white_m-200 text-white_m-200"></span>
                        <div className="relative flex flex-col justify-center p-4 bg-white_m-200 shadow-2xl rounded-3xl h-[80vh] w-full overflow-hidden">
                            <div className="flex flex-col mt-5 mb-8">
                                <h2 className="box-login__title">OTP</h2>
                                <p className="text-center text-[11px] font-medium text-black_m-300 mt-7">
                                    Mohon masukan kode OTP, yang telah
                                    dikirimkan ke nomor WA-mu di
                                </p>
                                <p className="text-center text-black_m-400 text-sm">
                                    {data.noHp}
                                </p>
                            </div>
                            <div className="flex flex-col justify-around">
                                <form
                                    ref={formRegister}
                                    onSubmit={processVerifyOtp}
                                >
                                    <input
                                        type="hidden"
                                        name="namaLengkap"
                                        value={data.namaLengkap}
                                    />
                                    <input
                                        type="hidden"
                                        name="noHp"
                                        value={data.noHp}
                                    />
                                    <input
                                        type="hidden"
                                        name="password"
                                        value={data.password}
                                    />
                                    <input
                                        type="hidden"
                                        name="layanan"
                                        value={data.layanan && "Setuju"}
                                    />
                                    <div className="mb-2 text-center">
                                        <label
                                            htmlFor="kode_otp"
                                            className="label-login"
                                        >
                                            Kode OTP
                                        </label>
                                    </div>
                                    <div className="mb-2 flex flex-col  items-center">
                                        <InputOtp
                                            length={6}
                                            name="kode_otp"
                                            isRequired
                                            variant="bordered"
                                        />
                                    </div>
                                    <div className="my-4 text-[11px] relative flex justify-center">
                                        <CountdownTimer
                                            SendOtpCode={SendOtpCode}
                                            noHp={data.noHp}
                                        />
                                    </div>

                                    <Button loading={loadButton} type="submit">
                                        Verifikasi
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </motion.div>
                    {showNotif ? (
                        <AlertSuccess
                            text={msgNotif.messageResponse}
                            apiText={msgNotif.messageApi}
                            notif={setShowNotif}
                            page="login"
                        />
                    ) : showNotif === false ? (
                        <AlertFailed
                            text={msgNotif.messageResponse}
                            apiText={msgNotif.messageApi}
                            notif={setShowNotif}
                        />
                    ) : (
                        ""
                    )}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default VerifyOtp;
